import { ArrowLeft, Search as SearchIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useKeyboardNavigation } from "@/hooks/useKeyboardNavigation";
import { useSearchState } from "@/hooks/useSearchState";

const Search = () => {
  const navigate = useNavigate();
  const {
    state,
    handleSearch,
    handleQueryChange,
    navigateToSession,
    searchParams,
  } = useSearchState();
  
  // Enable keyboard shortcuts for back navigation
  useKeyboardNavigation({
    onBack: () => navigate("/dashboard"),
  });

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="container mx-auto px-4 py-4">
          <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Button>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-semibold mb-6">Search Messages</h1>

        <div className="flex gap-2 mb-8">
          <Input
            value={state.query}
            onChange={(e) => handleQueryChange(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            placeholder="Search your conversations..."
            className="flex-1"
          />
          <Button onClick={handleSearch} disabled={state.loading}>
            <SearchIcon className="h-4 w-4 mr-2" />
            Search
          </Button>
        </div>

        {state.loading ? (
          <p className="text-center text-muted-foreground">Searching...</p>
        ) : state.results.length === 0 ? (
          <Card>
            <CardContent className="py-12 text-center">
              <p className="text-muted-foreground">
                {searchParams.get("q") ? "No results found" : "Enter a search term to begin"}
              </p>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Found {state.results.length} result{state.results.length !== 1 ? "s" : ""}
            </p>
            {state.results.map((result) => (
              <Card
                key={result.id}
                className="cursor-pointer hover:shadow-md transition-shadow"
                onClick={() => navigateToSession(result.session_id)}
              >
                <CardHeader>
                  <CardTitle className="text-base">{result.session_name}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground line-clamp-3">
                    {result.content}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default Search;
